/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */

import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import Form from "react-bootstrap/Form";
import { FadeLoader } from "react-spinners";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {
  login,
  loginWithGoogle,
  resendOTP,
  updateFcmToken,
} from "../../../actions/auth";
import axios from "axios";
import { LoginMain } from "../../../styles/common.style";
import {
  GoogleLogin,
  hasGrantedAnyScopeGoogle,
  useGoogleLogin,
} from "@react-oauth/google";
import { requestAndGetFCMToken, onMessageListener } from "../../../utils/fcm";

// import FacebookLogin from "react-facebook-login";

const Login = ({
  login,
  loginWithGoogle,
  isAuthenticated,
  loading,
  isVerified,
  loginSuccess,
  resendOTP,
  user,
  updateFcmToken,
}) => {
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });

  const { email, password } = formData;
  //const GOOGLE_AUTH_URL = 'https://apistaging.mybodysolutions.com/api/v1/google/redirect';
  const FACEBOOK_AUTH_URL =
    "https://apistaging.mybodysolutions.com/api/v1/facebook/redirect";
  const GOOGLE_CLIENT_ID =
    "559668091821-hl4e83cs4oqhb8cedoa7ii5r2ehl3oij.apps.googleusercontent.com";
  const GOOGLE_CLIENT_CALLBACK =
    "https://staging.mybodysolutions.com/auth/callback";

  const GOOGLE_AUTH_URL = `https://accounts.google.com/o/oauth2/v2/auth?client_id=${GOOGLE_CLIENT_ID}&redirect_uri=${GOOGLE_CLIENT_CALLBACK}&response_type=code&scope=email%20profile`;

  const navigate = useNavigate();

  const [showPassword, setShowPassword] = useState(false);
  const [showPasswordConfirm, setShowPasswordConfirm] = useState(false);

  useEffect(() => {
    const handleFCMToken = async () => {
      if (loginSuccess && isAuthenticated && isVerified) {
        const fcmToken = await requestAndGetFCMToken();

        if (fcmToken) {
          // Send token to backend, setup listener, etc.
          updateFcmToken(fcmToken); // no await
          onMessageListener(); // no await
        } else {
          console.warn("FCM token not available");
        }
        let assessmentUrl = "/";
        if (
          user?.user?.userAssessmentRuns &&
          user?.user?.userAssessmentRuns?.status === "cancelled"
        ) {
          assessmentUrl = "/user-assessments/re-take";
        } else {
          switch (user?.user?.userAssessmentRuns?.progress) {
            case "intake_form":
              assessmentUrl = "/welcome-to-assessment";
              break;
            case "assessment":
              assessmentUrl = "/user-assessments";
              break;
            case "completed":
              assessmentUrl = "/my-programs";
              break;
            default:
              assessmentUrl = "/welcome-to-assessment";
          }
        }
        // ✅ Move this here: Always run regardless of token success
        navigate(assessmentUrl, { replace: true });
      }
    };

    handleFCMToken();
  }, [loginSuccess, isAuthenticated, isVerified]);

  const onChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const onSubmit = (e) => {
    e.preventDefault();
    login(email, password);
  };

  if (loginSuccess && !isVerified) {
    resendOTP({ email: email });
    navigate("/verify-email", { state: { email } });
  }
  if (!loginSuccess) {
    loading = false;
  }

  const facebookLogin = async () => {
    window.open(FACEBOOK_AUTH_URL, "_self");
  };

  const googleLogin = async () => {
    window.open(GOOGLE_AUTH_URL, "_self");
  };

  const handleSuccess = (credentialResponse) => {
    const token = credentialResponse.access_token; // The JWT token
    loginWithGoogle(token, "google");
  };

  const handleError = () => {};

  const responseFacebook = (response) => {
    if (response.accessToken) {
      loginWithGoogle(response.accessToken, "facebook");
    }
  };

  const loginF = useGoogleLogin({
    onSuccess: (codeResponse) => handleSuccess(codeResponse),
    onError: (error) => handleError,
  });

  return (
    <>
      <div className="login-form-block">
        <div className="login-form-block-title">
          <h2>Sign In</h2>
        </div>
        <Form onSubmit={onSubmit} id="call_form" className="form-main">
          {/* Loader overlay */}
          {loading && (
            <div className="loader-overlay">
              <FadeLoader color={"#FB1417"} loading={loading} />
            </div>
          )}

          <Form.Group className="form_signup">
            <Form.Control
              type="email"
              placeholder="Email Address "
              name="email"
              value={email}
              onChange={onChange}
              required
            />
            <div className="form-sign-icon">
              <img src="/images/mail-icon.svg" alt="icon-block" />
            </div>
            {/* <Form.Text className="text-muted">
            We'll never share your email with anyone else.
          </Form.Text> */}
          </Form.Group>

          <Form.Group className="form_signup">
            <Form.Control
              type={showPasswordConfirm ? "text" : "password"}
              placeholder="Password"
              value={password}
              onChange={onChange}
              name="password"
              required
            />
            <span
              toggle="#password-field1"
              className={
                showPasswordConfirm
                  ? "fa fa-fw fa-eye field-icon toggle-password"
                  : "fa fa-fw fa-eye-slash field-icon toggle-password "
              }
              onClick={() => setShowPasswordConfirm(!showPasswordConfirm)}
            ></span>
            <div className="form-sign-icon">
              <img src="/images/password-icon.svg" alt="icon-block" />
            </div>
          </Form.Group>
          <div className="forgot-link">
            <Link to="/forgot-password">Forgot Password?</Link>
          </div>
          <div className="bottom-auth-block">
            <div className="common-btn-main">
              <button className="btn btn-common-auth" disabled={loading}>
                Sign in
              </button>
            </div>
            <p className="sign-text-block">
              Don't have an account? <Link to="/signup">Create Account</Link>
            </p>
          </div>
          {/* <Form.Group className='form-group loader_custom'> */}
          {/* <div className='forgot already'>
              <Link to='/forgot-password'>Forgot Password?</Link>
            </div> */}
          {/* {loading ? (
              <FadeLoader color={'#FB1417'} height={10} />
            ) : (
              <Form.Control type='submit' value='sign In' className='submit-btn w-100 pb-3' required />
            )} */}
          {/* <p className='already'>
              Don’t have an account? <Link to='/signup'>Sign Up</Link>
            </p> */}
          {/* </Form.Group> */}

          {/* <Form.Group className="mb-3" >
          <Form.Check type="checkbox" label="Check me out" />
        </Form.Group>
        <Button variant="secondary" type="submit">
          Submit
        </Button> */}

          {/* <button type='button' onClick={googleLogin}>
          Login with Google
        </button>
        <button type='button' onClick={facebookLogin}>
          Login with Facebook
        </button> */}
          <div className="social-login-block">
            {/* <div className='social-login-block-inner'>
              <button className='social-login-btn'>
                <img src='/images/google-icon.svg' alt='icon' />
              </button>
            </div>
            <div className='social-login-block-inner'>
              <button className='social-login-btn'>
                <img src='/images/facebook-icon.svg' alt='icon' />
              </button>
            </div>
            <div className='social-login-block-inner'>
              <button className='social-login-btn'>
                <img src='/images/apple-icon.svg' alt='icon' />
              </button>
            </div> */}
            <div className="social-login-block-inner">
              {/* <GoogleLogin
                  onSuccess={handleSuccess}
                  onError={handleError}
                  scope='https://www.googleapis.com/auth/user.phonenumbers.read https://www.googleapis.com/auth/userinfo.profile https://www.googleapis.com/auth/userinfo.email'
                  theme="outline"
                  size="large"
                  text="continue_with"
                  type="icon"
                  cookiePolicy={'single_host_origin'}
                /> */}
              <button
                type="button"
                className="social-login-btn"
                onClick={() => loginF()}
              >
                <img src="/images/google-icon.svg" alt="icon" />
              </button>
            </div>

            {/* <div className="social-login-block-inner">
              <FacebookLogin
                appId="471605882666485"
                autoLoad={false}
                fields="name,email,picture"
                callback={responseFacebook}
                textButton=""
                onFailure={(error) =>
                  console.error("Facebook Login Error:", error)
                }
                cssClass="social-login-btn"
                icon="fa-facebook"
              />
            </div> */}
            <div className="social-login-block-inner">
              <button className="social-login-btn">
                <img src="/images/apple-icon.svg" alt="icon" />
              </button>
            </div>
          </div>
        </Form>
      </div>
    </>
  );
};

Login.propTypes = {
  login: PropTypes.func.isRequired,
  loginWithGoogle: PropTypes.func.isRequired,
  updateFcmToken: PropTypes.func.isRequired,
  isAuthenticated: PropTypes.bool,
  isVerified: PropTypes.bool,
  loginSuccess: PropTypes.bool,
  resendOTP: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  isAuthenticated: state.auth.isAuthenticated,
  loading: state.auth.loading,
  isVerified: state.auth.isVerified,
  loginSuccess: state.auth.loginSuccess,
  user: state.auth.user || null,
});

export default connect(mapStateToProps, {
  login,
  loginWithGoogle,
  resendOTP,
  updateFcmToken,
})(Login);
